<template>
  <div class="confirmation">
    <div class="confirmation-message">
      <p>
      As no valid Xignite ID has been entered, it seems you are attempting to add a cryptocurrency that is not supported by our data provider.
        </p>
      <p>
        This cryptocurrency <span class="strong">cannot</span> be added as a recommendation in a service, and should only be added for the purpose of Marthetron compliance.
      </p>
      <p>
        Do you wish to continue?
      </p>
    </div>
    <button @click="confirmAddCrypto" class="btn-small waves-effect waves-light teal accent-4 confirmation-button">Yes</button>
    <button @click="cancelAddCrypto" class="btn-small waves-effect waves-light teal accent-4 confirmation-button">No</button>
  </div>
</template>

<script>
export default {
  methods: {
    confirmAddCrypto() {
      this.showConfirmation = false;
      this.$emit('addCryptoConfirmed');
    },
    cancelAddCrypto() {
      this.showConfirmation = false;
      this.$emit('addCryptoCancelled');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.confirmation {
  font-size: 1.2rem;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  background-color: white;
  border: 1px solid #ccc;
  text-align: center;
  z-index: 1000;
}

.confirmation-message {
  margin-bottom: 10px;
}

.confirmation-button {
  margin: 5px;
}

</style>
